import React from 'react';
import raiseFlashMessage, {
  raiseFlashMessageError,
} from '@/utils/raiseFlashMessage';
import translate from '@/utils/translate';
import ConfirmModal from '@/components/confirm-modal';
import FlashMessage from '@/components/flash-message';
import useExtendExpirationDate from '@/hooks/mutations/use-extend-expiration-date';

const TITLE = '14-Day Extension for This Creator';
const BODY =
  'Extend the expiration date of this application by 14 days. This is a one-time extension and cannot be repeated.';
const CONFIRM_LABEL = 'Give 14 Days';
const SUCCESS_FLASH = '14-day extension successfully applied';
const FAILURE_FLASH = 'Unable to extend deadline at this time';

type ExtendDeadlineModalProps = {
  open: boolean;
  onClose: () => void;
  paidGigId: string;
  currentExpiresAt: string | null;
};

function ExtendDeadlineModal({
  open,
  onClose,
  paidGigId,
  currentExpiresAt,
}: ExtendDeadlineModalProps) {
  const extendExpiration = useExtendExpirationDate();

  const handleConfirm = () => {
    extendExpiration.mutate(
      {paidGigId, currentExpiresAt},
      {
        onSuccess: () => {
          raiseFlashMessage({
            status: 'success',
            mode: 'light',
            message: <FlashMessage.Banner title={translate(SUCCESS_FLASH)} />,
          });
          onClose();
        },
        onError: () => {
          raiseFlashMessageError({title: translate(FAILURE_FLASH)});
        },
      }
    );
  };

  const stopCardClick = (event: React.SyntheticEvent) => {
    event.stopPropagation();
  };

  return (
    <span role="presentation" onClick={stopCardClick} onKeyDown={stopCardClick}>
      <ConfirmModal
        open={open}
        title={TITLE}
        body={BODY}
        confirmLabel={CONFIRM_LABEL}
        confirmAppearance="neutral"
        isLoading={extendExpiration.isLoading}
        isCancelDisabled={extendExpiration.isLoading}
        onConfirm={handleConfirm}
        onCancel={onClose}
      />
    </span>
  );
}

export default ExtendDeadlineModal;
